import { render, staticRenderFns } from "./PatientCardHistoryTable.vue?vue&type=template&id=3257b2e8&scoped=true"
import script from "./PatientCardHistoryTable.vue?vue&type=script&lang=js"
export * from "./PatientCardHistoryTable.vue?vue&type=script&lang=js"
import style0 from "./PatientCardHistoryTable.vue?vue&type=style&index=0&id=3257b2e8&prod&scoped=true&lang=css"
import style1 from "./PatientCardHistoryTable.vue?vue&type=style&index=1&id=3257b2e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3257b2e8",
  null
  
)

export default component.exports